export const getFormValuesDiff = (
	dirtyValues: Record<string, unknown>,
	currentValues: Record<string, unknown>,
) => {
	const changedValues = Object.keys(dirtyValues).reduce((acc, field) => {
		acc[field] = currentValues[field];
		return acc;
	}, {});

	return changedValues;
};
